import { render, staticRenderFns } from "./TipjarSettings.vue?vue&type=template&id=3822622d"
import script from "./TipjarSettings.vue?vue&type=script&lang=js"
export * from "./TipjarSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports